import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import { toast } from '@livable/saas-react-components';
import { Button, Typography, Link } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { useSubmeterBillModalStyles } from './styles';
import SubmeterCsvTableModal from 'src/pages/AllocationTablesPage/AllocationSubmeteredUtility/SubmeterCsvTableModal';
import CsvFileUploader from 'src/pages/AllocationTablesPage/AllocationSubmeteredUtility/CsvFileUploader';
import moment from 'moment';
import { generateCsv, generateRedactedCsv } from 'src/pages/AllocationTablesPage/AllocationSubmeteredUtility/tools';
import SubmeterChargesErrorsTable from 'src/pages/AllocationTablesPage/AllocationSubmeteredUtility/SubmeterChargesErrorsTable';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
export const SubmeterBillModalContent = observer(_ref => {
  var _store$properties;
  let handleClose = _ref.handleClose,
    billTabStoreObject = _ref.billTabStoreObject,
    isPreviewOnly = _ref.isPreviewOnly,
    submeterFinalStateInfoExt = _ref.submeterFinalStateInfoExt,
    propertyId = _ref.propertyId,
    propertyAddress = _ref.propertyAddress,
    utilityName = _ref.utilityName,
    utilityId = _ref.utilityId,
    buildingId = _ref.buildingId,
    allocationCycleId = _ref.allocationCycleId,
    billingCycleId = _ref.billingCycleId;
  const classes = useSubmeterBillModalStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const utilityDataFromProviders = ((_store$properties = store.properties) === null || _store$properties === void 0 || (_store$properties = _store$properties.propertyUtilities) === null || _store$properties === void 0 ? void 0 : _store$properties.find(u => u.utilityId === utilityId)) || {};
  console.log('SubmeterBillModalContent', submeterFinalStateInfoExt);
  const seedRowsFromFinalState = () => {
    var _submeterFinalStateIn;
    return (_submeterFinalStateIn = submeterFinalStateInfoExt === null || submeterFinalStateInfoExt === void 0 ? void 0 : submeterFinalStateInfoExt.map(r => {
      var _r$residentAccountFul;
      return _objectSpread(_objectSpread({}, r), {}, {
        fullName: (_r$residentAccountFul = r === null || r === void 0 ? void 0 : r.residentAccountFullName) !== null && _r$residentAccountFul !== void 0 ? _r$residentAccountFul : 'Loading...',
        startReadDate: moment(r.startMeterDateOnly).format('MM/DD/YYYY'),
        endReadDate: moment(r.endMeterDateOnly).format('MM/DD/YYYY'),
        utilityUnit: r.unitsOfMeasure,
        utilityCharge: r.allocationCharge,
        serviceDays: r.serviceDaysInPeriod
      });
    })) !== null && _submeterFinalStateIn !== void 0 ? _submeterFinalStateIn : [];
  };
  const _useState = useState(seedRowsFromFinalState),
    _useState2 = _slicedToArray(_useState, 2),
    fileContents = _useState2[0],
    setFileContents = _useState2[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState3 = useState(isPreviewOnly),
    _useState4 = _slicedToArray(_useState3, 2),
    sentStatus = _useState4[0],
    setSentStatus = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    residenciesData = _useState6[0],
    setResidenciesData = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDisabled = _useState8[0],
    setIsDisabled = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    userInitialCsvFileId = _useState0[0],
    setUserInitialCsvFileId = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    userEditedCsvFileId = _useState10[0],
    setUserEditedCsvFileId = _useState10[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    uploadedFile = _useState12[0],
    setUploadedFile = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    dataToPassOver = _useState14[0],
    setDataToPassOver = _useState14[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    fileErrors = _useState16[0],
    setFileErrors = _useState16[1];
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    applyChargesModalState = _useState18[0],
    setApplyChargesModalState = _useState18[1];
  const getResidenciesMultiproperty = async () => {
    const resp = await store.residencies.searchResidenciesAggregateAsync.run({
      portfolioIds: [],
      propertyIds: [propertyId],
      includeEmptyUnits: false,
      sortBy: 'unitName',
      sortOrder: 'asc',
      statuses: [RESIDENCY_STATUS_KEY_VALUES.Current, RESIDENCY_STATUS_KEY_VALUES.FormerActive]
    }, [propertyId]);
    return resp;
  };
  const uploadRedactedFile = async fileBlob => {
    let uploadFileResult;
    if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
      uploadFileResult = await store.files.uploadFileViaPresignedUrlExperimentAsync.run({
        file: fileBlob,
        createdBy: store.account.userProfile.id
      });
    } else {
      uploadFileResult = await store.files.uploadFileAsync.run({
        file: fileBlob
      });
    }
    return uploadFileResult;
  };
  const generateCsvTemplate = async event => {
    event.preventDefault();
    event.stopPropagation();
    const filename = propertyAddress ? "".concat(propertyAddress.replace(/ /g, '_'), ".csv") : "".concat(propertyId, ".csv");
    const data = generateCsv(residenciesData);
    if (!data) return;
    const encodedUri = window.URL.createObjectURL(new Blob([data], {
      type: 'application/octet-stream'
    }));
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const fetchResidenciesData = async function () {
    let rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fileContents;
    return getResidenciesMultiproperty().then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        var _resp$response;
        const data = (resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.buildingResidency) || [];
        setResidenciesData(data);
        if (rows !== null && rows !== void 0 && rows.length) {
          submeterFinalStateInfoExt.forEach(item => {
            const residencyData = data.find(r => r.accountId === item.residentAccountId || r.accountId === item.accountId);
            if (residencyData) {
              var _ref2, _residencyData$fullna;
              item.setResidentAccountFullName((_ref2 = (_residencyData$fullna = residencyData === null || residencyData === void 0 ? void 0 : residencyData.fullname) !== null && _residencyData$fullna !== void 0 ? _residencyData$fullna : residencyData === null || residencyData === void 0 ? void 0 : residencyData.fullName) !== null && _ref2 !== void 0 ? _ref2 : "".concat(residencyData.firstname, " ").concat(residencyData.lastname));
            }
          });
          setFileContents(current => (current !== null && current !== void 0 ? current : []).map(item => {
            var _ref3, _residencyData$fullna2;
            if (item.isEdited) return item;
            const residencyData = data.find(r => r.accountId === item.residentAccountId || r.accountId === item.accountId);
            return _objectSpread(_objectSpread({}, item), {}, {
              residencyData: residencyData || {},
              fullName: residencyData ? (_ref3 = (_residencyData$fullna2 = residencyData === null || residencyData === void 0 ? void 0 : residencyData.fullname) !== null && _residencyData$fullna2 !== void 0 ? _residencyData$fullna2 : residencyData === null || residencyData === void 0 ? void 0 : residencyData.fullName) !== null && _ref3 !== void 0 ? _ref3 : "".concat(residencyData.firstname, " ").concat(residencyData.lastname) : ''
            });
          }));
        }
        setIsDisabled(false);
      }
    });
  };
  useEffect(() => {
    console.log('SubmeterBillModalContent useEffect');
    fetchResidenciesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isFirstSeed = useRef(true);
  useEffect(() => {
    if (isFirstSeed.current) {
      isFirstSeed.current = false;
      return;
    }
    if (uploadedFile || (fileContents !== null && fileContents !== void 0 ? fileContents : []).some(r => r.isEdited)) return;
    const rows = seedRowsFromFinalState();
    setFileContents(rows);
    fetchResidenciesData(rows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submeterFinalStateInfoExt]);
  const saveChargesHistory = async () => {
    const chargesConfig = (fileContents || []).map(ch => {
      return {
        unitName: String(ch.unitName),
        residentAccountId: ch.accountId,
        isProcessed: true,
        startMeterRead: parseFloat(ch.startMeterRead),
        endMeterRead: parseFloat(ch.endMeterRead),
        startMeterDateOnly: moment(ch.startReadDate).format('YYYY-MM-DD'),
        endMeterDateOnly: moment(ch.endReadDate).format('YYYY-MM-DD'),
        serviceDaysInPeriod: parseInt(ch.serviceDays),
        meterRate: parseFloat(ch.meterRate),
        meterUsage: parseFloat(ch.meterUsage),
        unitsOfMeasure: ch.utilityUnit,
        allocationCharge: parseFloat(ch.utilityCharge)
      };
    });
    const createAllocationChargesAsyncResp = await store.allocations.createAllocationChargesAsync.run({
      propertyId: propertyId,
      buildingId: buildingId,
      utilityId: utilityId,
      allocationCycleId: allocationCycleId,
      billingCycleId: billingCycleId,
      userInitialCsvFileId,
      userEditedCsvFileId,
      submeterCharges: chargesConfig
    });
    if (createAllocationChargesAsyncResp !== null && createAllocationChargesAsyncResp !== void 0 && createAllocationChargesAsyncResp.isSuccessful) {
      console.log('createAllocationChargesAsyncResp', createAllocationChargesAsyncResp);
      // TO DO : chargesHistoryResult?.isSuccessful
    }
  };
  const postChargeTransactions = async rawChargesData => {
    var _rawChargesData$, _resp$response2;
    const chargeErrorsInner = [];
    const data = {
      propertyId: ((_rawChargesData$ = rawChargesData[0]) === null || _rawChargesData$ === void 0 ? void 0 : _rawChargesData$.propertyId) || '',
      chargeTransactions: rawChargesData.map(item => {
        const tx = {
          amount: +item.amount,
          type: item.type,
          utilityId: item.utilityId,
          propertyUtilityId: item.propertyUtilityId,
          notes: item.notes,
          memo: item.memo,
          notifyResident: item.notifyResident,
          title: item.title,
          propertyId: item.propertyId,
          userAccountId: item.userAccountId
        };
        if (item.appfolioChargeOnDate) {
          tx.appfolioChargeOnDate = item.appfolioChargeOnDate;
        }
        return tx;
      })
    };
    const resp = await store.transaction.postBulkCustomChargeAsync.run(data);
    if (resp && resp !== null && resp !== void 0 && resp.response && (resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 || (_resp$response2 = _resp$response2.result) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.length) > 0) {
      var _resp$response3;
      resp === null || resp === void 0 || (_resp$response3 = resp.response) === null || _resp$response3 === void 0 || _resp$response3.result.map(i => {
        if (!i.isCreated) {
          var _rawChargesData$find, _rawChargesData$find2;
          const d = _objectSpread(_objectSpread({}, i === null || i === void 0 ? void 0 : i.chargeTransaction), {}, {
            name: (_rawChargesData$find = rawChargesData.find(el => {
              var _i$chargeTransaction;
              return el.userAccountId === (i === null || i === void 0 || (_i$chargeTransaction = i.chargeTransaction) === null || _i$chargeTransaction === void 0 ? void 0 : _i$chargeTransaction.userAccountId);
            })) === null || _rawChargesData$find === void 0 ? void 0 : _rawChargesData$find.name,
            number: (_rawChargesData$find2 = rawChargesData.find(el => {
              var _i$chargeTransaction2;
              return el.userAccountId === (i === null || i === void 0 || (_i$chargeTransaction2 = i.chargeTransaction) === null || _i$chargeTransaction2 === void 0 ? void 0 : _i$chargeTransaction2.userAccountId);
            })) === null || _rawChargesData$find2 === void 0 ? void 0 : _rawChargesData$find2.number
          });
          chargeErrorsInner.push(d);
        }
      });
      if (chargeErrorsInner.length > 0) {
        store.transaction.setBulkCustomChargeErrorElement(chargeErrorsInner);
      }
    }
    return chargeErrorsInner;
  };
  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isLoadingCharges = _useState20[0],
    setIsLoadingCharges = _useState20[1];
  const applyChargesActionHandler = async _ref4 => {
    let action = _ref4.action,
      objectToPassOver = _ref4.objectToPassOver;
    setApplyChargesModalState(false);
    if (action === 'submit') {
      setIsLoadingCharges(true);
      await postChargeTransactions(objectToPassOver);
      await saveChargesHistory();
      if (!isPreviewOnly) {
        await billTabStoreObject.fetchSubmeterBillFinalStateModal();
      }
      await fetchResidenciesData();
      setIsDisabled(true);
      setSentStatus(true);
      setIsLoadingCharges(false);
      // await fetchData();
    }
  };
  const getSubmeterTransactionTitle = tableRow => {
    const meterReadStart = typeof tableRow.startMeterRead !== 'undefined' ? Number(tableRow.startMeterRead) : '';
    const meterReadEnd = typeof tableRow.endMeterRead !== 'undefined' ? Number(tableRow.endMeterRead) : '';
    const costMultiplier = typeof tableRow.meterRate !== 'undefined' ? Number(tableRow.meterRate).toFixed(2) : '';
    const servicePhone = typeof tableRow.servicePhoneNumber !== 'undefined' ? tableRow.servicePhoneNumber : '';
    const providerName = typeof tableRow.utilityProviderName !== 'undefined' ? tableRow.utilityProviderName : '';
    return "".concat(utilityName, " By Submeter, Service Period: ").concat(tableRow.startReadDate, " - ").concat(tableRow.endReadDate, ", ").concat(providerName ? '(' + providerName + ')' : '', " ").concat(meterReadStart || meterReadEnd ? 'Readings: ' + meterReadStart + ' - ' + meterReadEnd : '', ", Usage: ").concat(tableRow.meterUsage, " (").concat(tableRow.utilityUnit, ") ").concat(costMultiplier ? 'Rate: ' + costMultiplier : '', " ").concat(servicePhone ? 'Service Phone: ' + servicePhone : '', ".");
  };
  const transformCsvData = sourceCsv => {
    const result = (sourceCsv || []).map(row => {
      return {
        amount: row.utilityCharge,
        memo: '',
        notes: '',
        notifyResident: false,
        propertyId: propertyId,
        propertyUtilityId: utilityDataFromProviders !== null && utilityDataFromProviders !== void 0 && utilityDataFromProviders.propertyUtilityId ? utilityDataFromProviders === null || utilityDataFromProviders === void 0 ? void 0 : utilityDataFromProviders.propertyUtilityId : '',
        title: getSubmeterTransactionTitle(row),
        type: 'Utility',
        userAccountId: row.accountId,
        utilityId: utilityId,
        number: row.unitName,
        name: row.fullName
      };
    });
    setDataToPassOver(result);
  };
  const prepareRedactedFileBlod = async () => {
    const data = generateRedactedCsv(fileContents);
    const proposedFileName = "".concat(propertyAddress, "_redacted.csv");
    const fileData = new File([data], proposedFileName, {
      type: 'application/octet-stream'
    });
    const uploadedFileResult = await uploadRedactedFile(fileData);
    if (uploadedFileResult !== null && uploadedFileResult !== void 0 && uploadedFileResult.isSuccessful) {
      setUserEditedCsvFileId(uploadedFileResult.response);
    }
  };
  const applyChargesClickHandler = event => {
    event.preventDefault();
    setIsDisabled(true);
    transformCsvData(fileContents);
    // We need to upload redacted file if it was edited (some rows has isEdited = true)
    if (fileContents.some(r => r.isEdited)) {
      prepareRedactedFileBlod();
    }
    setApplyChargesModalState(true);
    setIsDisabled(false);
  };
  const fileSelectCallback = async contents => {
    if (contents && Object.keys(contents).length) {
      const fileName = contents.fileName,
        csvData = contents.csvData,
        errors = contents.errors;
      setUploadedFile(fileName);
      await setFileContents(csvData);
      setFileErrors(errors);
      await fetchResidenciesData();
      if (typeof contents.fileResponse !== 'undefined') {
        // assume that Successful response will give us a string or something not undefined
        setUserInitialCsvFileId(contents.fileResponse);
      }
      transformCsvData(csvData);
    } else {
      setUploadedFile(null);
      setFileContents(null);
      setFileErrors(null);
      store.transaction.setBulkCustomChargeErrorElement([]);
    }
  };
  const getModalBody = () => {
    const amountsArr = (dataToPassOver || []).map(item => item.amount);
    const amount = amountsArr.length ? amountsArr.reduce((prev, next) => Number(prev) + Number(next)) : 0;
    const chargeType = 'charge';
    return /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      color: "light"
    }, t('post_charge_modal.confirm_posting', {
      amount: '$' + Number(amount).toFixed(2),
      chargeType: chargeType
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: classes.amountLine
    }, dataToPassOver.map(i => /*#__PURE__*/React.createElement("div", {
      key: i.unitMeterId,
      className: classes.unit
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: ''
    }, "Unit: ", i.number, ' ', /*#__PURE__*/React.createElement("span", null, ' ', "- ", i.name, " - ", '$' + Number(i.amount).toFixed(2)), /*#__PURE__*/React.createElement("p", null, "(", i.type, ": ", i.title, ")"))))));
  };
  const getModalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, "".concat(utilityName, " Allocated By Submeter"));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, !isPreviewOnly && /*#__PURE__*/React.createElement("div", {
    className: classes.uploadSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Upload CSV reads'), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapperContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body6",
    component: "p",
    marginBottom: "8px"
  }, 'Upload csv submeter reads to auto-fill the fields below and press Apply.'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body6"
  }, ' ', "( You can", ' ', /*#__PURE__*/React.createElement(Link, {
    href: '',
    onClick: generateCsvTemplate
  }, "generate and download CSV template here"), ' ', ")"))), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement(CsvFileUploader, {
    callback: fileSelectCallback,
    disabled: isDisabled || isLoadingCharges,
    label: 'Attach CSV sub meter reads',
    tooltipText: "".concat(t('allocations.livable_transparency'), " ").concat(t('allocations.you_share_bill')),
    isDisabledParent: isDisabled,
    isPreviewForm: true,
    noPreview: true,
    residenciesData: residenciesData && residenciesData.length ? residenciesData : []
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.groupWrapper, " ").concat(classes.submeterBillModalContent)
  }, /*#__PURE__*/React.createElement(SubmeterCsvTableModal, {
    submeterFinalStateInfoExt: submeterFinalStateInfoExt,
    fileContents: fileContents || [],
    saveCallback: data => {
      setFileContents(data);
    },
    sentStatus: sentStatus
  }))), store.transaction.bulkCustomChargeErrorElement.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.errorsSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.errorTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "error"
  }, "Error(s) in charge(s):")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.visibilitySetting
  }, /*#__PURE__*/React.createElement(SubmeterChargesErrorsTable, {
    chargeErrors: store.transaction.bulkCustomChargeErrorElement
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandartSmall
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    variant: "text",
    'custom-attribute': '880--new-billing-module'
  }, t('buttons.cancel'))), isPreviewOnly ? null : /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled || isLoadingCharges || !dataToPassOver.length,
    onClick: applyChargesClickHandler,
    variant: "contained",
    'custom-attribute': '880--new-billing-module'
  }, t('Apply charges')))))), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    headerText: 'Post charge(s)',
    subTitleText: getModalSubTitle,
    bodyComponent: getModalBody(),
    externalIsOpen: applyChargesModalState,
    callBack: applyChargesActionHandler,
    objectToPassOver: dataToPassOver,
    customTrigger: null
  }));
});